import { Component, HostBinding, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { SessionService } from '../../core/session.service';
import { AuthService } from '../../auth/auth.service';
import { TranslatePipe } from '@ngx-translate/core';
import { EstablishmentSwitcherComponent } from '../establishment-switcher/establishment-switcher.component';

@Component({
  selector: 'app-page-site-switcher',
  standalone: true,
  imports: [EstablishmentSwitcherComponent, TranslatePipe],
  templateUrl: './page-site-switcher.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./page-site-switcher.component.scss'],
})
export class PageSiteSwitcherComponent {
  @Input() inline = false;
  /** 'floating' = pastille flottante en haut à droite (comportement historique). */
  /** 'header' = intégré à gauche, au-dessus du titre/sous-titre de la page. */
  @Input() variant: 'floating' | 'header' = 'floating';

  readonly session = inject(SessionService);
  readonly auth = inject(AuthService);

  @HostBinding('class.header-variant')
  get isHeaderVariant(): boolean {
    return this.variant === 'header';
  }

  get isV2(): boolean {
    return !this.inline && this.auth.hasPermission('SUPERVISION');
  }

  onChanged(id: string): void {
    this.session.selectEstablishment(id);
  }
}
